import { NgModule } from '@angular/core';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import {DocumentManagementApiService} from './documentmanagement-api.service';

@NgModule({
  imports: [
    ConfigManagerModule
  ],
  providers: [
    DocumentManagementApiService,
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json'}},
  ]
})
export class SdkDocumentManagementModule { }
